import React, { useState, useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import { Modal } from 'react-bootstrap';
import 'react-toastify/dist/ReactToastify.css';
import { Link } from "react-router-dom";
import swal from 'sweetalert';

const AsnafDetailModal = ({ isOpen, onClose }) => {
  const [selectedItem, setSelectedItem] = useState('');
  const [items, setItems] = useState([]);
  const [numberOfPieces, setNumberOfPieces] = useState('');
  const [asnafList, setAsnafList] = useState([]);
  const [error, setError] = useState('');

  const fetchItems = async () => {
    try {
      const response = await axios.get('https://suhba.education.com.ly/back/api/food_items');
      setItems(response.data);
    } catch (error) {
      console.error('Error fetching items:', error);
      toast.error('فشل في تحميل الأصناف.');
    }
  };

  const fetchAsnafDetails = async () => {
    try {
      const response = await axios.get('https://suhba.education.com.ly/back/api/asnafdetails');
      if (response.status === 200) {
     
        setAsnafList(response.data);
      }
    } catch (error) {
      console.error('Error fetching asnaf details:', error);
      toast.error('فشل في تحميل التفاصيل.');
    }
  };

  useEffect(() => {
    if (isOpen) {
      const fetchData = async () => {
        await fetchItems();
      };
      fetchData();
    }
  }, [isOpen]);

  useEffect(() => {
    if (isOpen && items.length > 0) {
      fetchAsnafDetails();
      setSelectedItem('');
      setNumberOfPieces('');
    }
  }, [isOpen, items]);

  const handleChange = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) {
      setNumberOfPieces(value);
      setError('');
    } else {
      setError('يُسمح بالأرقام فقط');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (selectedItem && numberOfPieces) {
      const data = {
        ItemID: parseInt(selectedItem),
        numberofpieces: parseInt(numberOfPieces),
      };

      try {
    const response = await axios.post('https://suhba.education.com.ly/back/api/asnafdetails', data);
if (response.data.status === 202) {
      // Laravel returned custom message
          toast.error(response.data.message);
     }
    else if (response.status === 200 || response.status === 201) {
      toast.success('تمت إضافة الصنف بنجاح!');

      // Reset form
      setSelectedItem('');
      setNumberOfPieces('');

      // Refresh list
      fetchAsnafDetails();
    } 
      } catch (error) {
        toast.error('فشل في إضافة الصنف.');
      }
    }
  };

  const handleDeleteClick = async (id) => {
    const willDelete = await swal({
      title: "هل أنت متأكد من الحذف؟",
      text: "لن تتمكن من استرجاع البيانات بعد الحذف!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    });

    if (!willDelete) {
      swal("تم إلغاء الحذف");
      return;
    }

    try {
      const res = await axios.delete(`https://suhba.education.com.ly/back/api/asnafdetails/${id}`);
      setAsnafList(prev => prev.filter(item => item.asnafdetailsid !== id));

      await swal({
        title: "تم",
        text: "تم الحذف بنجاح",
        icon: "success",
        timer: 2000,
        button: false,
      });

    } catch (error) {
      console.error('Delete failed:', error);

      swal({
        title: "خطأ",
        text: error.response?.data?.message || 'فشل الحذف. حاول مرة أخرى.',
        icon: "error",
      });
    }
  };

  const handleEdit = async (index, id, value) => {
    const updatedList = [...asnafList];
    const updatedItem = { ...updatedList[index], numberofpieces: parseInt(value) };
    try {
      const response = await axios.put(
        `https://suhba.education.com.ly/back/api/asnafdetails/${id}`,
        {
          numberofpieces: updatedItem.numberofpieces,
          ItemID: updatedItem.ItemID,
        }
      );

      if (response.status === 200) {
        updatedList[index] = updatedItem;
        setAsnafList(updatedList);
        toast.success('تم التعديل بنجاح');
      } else {
        toast.error('حدث خطأ غير متوقع');
      }
    } catch (error) {
      console.error('Error updating item:', error);
      toast.error('فشل في التعديل');
    }
  };

  if (!isOpen) return null;

  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />
      <Modal className="modal fade" show={isOpen} centered dir="rtl">
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="modal-title fs-5">تفاصيل الأصناف</h1>
            <button type="button" className="btn-close" style={{marginLeft: 0 }}  onClick={onClose}></button>
          </div>

          <div className="modal-body py-1 px-3">
            <form onSubmit={handleSubmit}>
              <div className="row m-4">
                <div className="col-xl-6">
                  <label className="form-label">اختر الصنف:</label>
                  <select
                    className="form-control"
                    value={selectedItem}
                    onChange={(e) => setSelectedItem(e.target.value)}
                    required
                  >
                    <option value="">-- اختر صنفاً --</option>
                    {items.map(item => (
                      <option key={item.ItemID} value={item.ItemID}>
                        {item.Name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-xl-6">
                  <label className="form-label">عدد القطع:</label>
                  <input
                    type="text"
                    className="form-control"
                    value={numberOfPieces}
                    onChange={handleChange}
                    required
                  />
                  {error && <p className="text-danger text-sm mt-1">{error}</p>}
                </div>
              </div>

              <div className="modal-footer">
              
                <button type="submit" className="btn btn-primary btn-sm">
                  حفظ
                </button>
                  <button
                  type="button"
                  onClick={onClose}
                  className="btn btn-danger btn-sm light"
                >
                  إلغاء
                </button>
              </div>
            </form>

            {asnafList.length > 0 && (
              <div className="table-responsive mt-4">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>اسم الصنف</th>
                      <th>عدد القطع</th>
                      <th>إجراءات</th>
                    </tr>
                  </thead>
                  <tbody>
                    {asnafList.map((item, index) => (
                      <tr key={item.asnafdetailsid}>
                        <td>{index + 1}</td>
                        <td>{item.item.Name}</td>
                        <td>
                          <input
                            type="number"
                            className="form-control"
                            defaultValue={item.numberofpieces}
                            onBlur={(e) => handleEdit(index, item.asnafdetailsid, e.target.value)}
                          />
                        </td>
                        <td>
                          <Link onClick={() => handleDeleteClick(item.asnafdetailsid)}>
                            <i className="fas fa-trash-alt text-danger"></i>
                          </Link>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </Modal>
    </>
  );
};

export default AsnafDetailModal;
